import MobileDetect from 'mobile-detect'

export default {
  install (Vue) {
    const device = new MobileDetect(window.navigator.userAgent)
    Vue.prototype.$device = device
  }
}
